import apiRequest from "./ApiService";

export const requestStoreInvoice = async (param = "") => {
  try {
    return await apiRequest.post(`/store-invoice` + param);
  } catch (error) {
    return error;
  }
};
